import { Component, NgModule, Input } from '@angular/core';
import { SharedService } from "./shared.service";
import { User, VisitDistributionRow, UserFeatures } from './model/model.class';
import { Labels } from './model/language.model.class';

@Component({
  selector: 'vdt-component',
  templateUrl: './vdt.component.html',
  styleUrls: ['./vdt.component.css']
})

export class VdtComponent {

  @Input() accounId: string;
  @Input() user: User;
  @Input() labels: Labels;

  visitDistributionRows: VisitDistributionRow[];
  isDesc: boolean = false;
  column: string = '';

  public userFeatures;

  //objLoaderStatus: boolean;

  constructor(private sharedService: SharedService) {
    this.sharedService.visitDistributionEvent.subscribe(data => {
      this.visitDistributionRows = data;
    });

    this.sharedService.userEvent.subscribe(data => {
      this.visitDistributionRows = undefined;
    });

    //this.objLoaderStatus = false;
  }

  ngOnInit() {
    /*this.sharedService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });*/
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if(currentUser && currentUser.userTypes && currentUser.userTypes.length > 0) {
      this.userFeatures = this.sharedService.getTextualFunctionality(currentUser);
    }
  }

  private OpenTab(tabView) {
    this.sharedService.SwitchTab(tabView);
  }

  public visitFrequencyLabel(visitFrequencyBySalesRep, visitFrequencyProposed) {
    return visitFrequencyBySalesRep == 0 ? visitFrequencyProposed == 0 ? '' : this.visitFrequencyTranslation(visitFrequencyProposed) : visitFrequencyProposed == 0 ? this.visitFrequencyTranslation(visitFrequencyBySalesRep) + '\r\n(null)' : this.visitFrequencyTranslation(visitFrequencyBySalesRep) + '\r\n(' + this.visitFrequencyTranslation(visitFrequencyProposed) + ')';
  }
  public visitDayAdjustedLabel(visitDayAdjustedBySalesRep, visitDayAdjustedProposed) {
    return visitDayAdjustedBySalesRep == 0 ? visitDayAdjustedProposed == 0 ? '' : this.DaysTranslation(visitDayAdjustedProposed) : visitDayAdjustedProposed == 0 ? this.DaysTranslation(visitDayAdjustedBySalesRep) + '\r\n(null)' : this.DaysTranslation(visitDayAdjustedBySalesRep) + '\r\n(' + this.DaysTranslation(visitDayAdjustedProposed) + ')';
  }

  public visitRecurrencyLabel(visitRecurrency: string) {
    if (visitRecurrency != undefined) {
      let values = visitRecurrency.split(",");
      return values.length > 2 ? this.visitRecurrencyTranslation(values) : '';
    }
    return '';
  }

  private visitFrequencyTranslation(visitFrequencyValue) {
    if (visitFrequencyValue > 1)
      return visitFrequencyValue + ' ' + this.labels.Weeks['Weeks'];
    else
      return this.labels.Weeks['Weekly'];
  }

  private DaysTranslation(visitDayAdjustedValue) {
    return this.labels.Days[visitDayAdjustedValue];
  }

  private visitRecurrencyTranslation(visitRecurrencyValues) {
    var period = visitRecurrencyValues[0].trim();
    var periodNumber = visitRecurrencyValues[1].trim();
    var day = visitRecurrencyValues[2].trim();
    var weekDay = visitRecurrencyValues[3] ? visitRecurrencyValues[3].trim() : "";
    if (period == "weekly") {
      if (parseInt(periodNumber) > 1)
        return this.labels.VisitDistributionTable['VisitRecurrenceRule']['multipleWeeks'].replace('{0}', periodNumber).replace('{1}', this.DaysTranslation(day));
      else
        return this.labels.VisitDistributionTable['VisitRecurrenceRule']['singleWeek'].replace('{0}', this.DaysTranslation(day));
    } else {
      if (parseInt(periodNumber) > 1)
        return this.labels.VisitDistributionTable['VisitRecurrenceRule']['multipleMonths'].replace('{0}', periodNumber).replace('{1}', this.DaysTranslation(day));
      else
        return this.labels.VisitDistributionTable['VisitRecurrenceRule']['singleMonth'].replace('{0}', this.labels.OrdinalNumbers[day]).replace('{1}', this.DaysTranslation(weekDay));
    }
  }

  public GetLabel(name) {
    return this.labels.VisitDistributionTable[name]['label'] != undefined ? this.labels.VisitDistributionTable[name]['label'] : this.labels.VisitDistributionTable[name];
  }

  public Sort(property) {
    let direction = this.SetSortDirection(property);
    let me = this;

    this.visitDistributionRows.sort(function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return me.ExecuteSort(value1, value2, direction)
    });
  }

  public Sort2(column, primaryProperty, secondaryProperty) {
    let direction = this.SetSortDirection(column);
    let me = this;

    this.visitDistributionRows.sort(function (a, b) {
      var value1 = a[primaryProperty] != 0 ? a[primaryProperty] : a[secondaryProperty];
      var value2 = b[primaryProperty] != 0 ? b[primaryProperty] : b[secondaryProperty];
      return me.ExecuteSort(value1, value2, direction)
    });

  }
  private SetSortDirection(column) {
    if (this.column == column) {
      this.isDesc = !this.isDesc; //change the direction    
    }
    else {
      this.isDesc = true;
      this.column = column;
    }
    return this.isDesc ? 1 : -1;
  }

  private ExecuteSort(value1, value2, direction) {
    if (value1 < value2) {
      return -1 * direction;
    }
    else if (value1 > value2) {
      return 1 * direction;
    }
    else {
      return 0;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/vdt.component.ts